import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faDiscord, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import '../styles/TopContactBar.scss';

const TopContactBar: React.FC = () => {
  const openWhatsAppChat = () => {
    window.open(`https://wa.me/14087094522?text=Hi, I need help with my assignment!`, '_blank');
  };

  const openDiscord = () => {
    window.open('https://discord.com/users/683462599651754073', '_blank');
  };

  const openInstagram = () => {
    window.open('https://instagram.com/homework_guy_official', '_blank');
  };

  const openEmail = () => {
    window.open('mailto:support@homeworkguy.live', '_blank');
  };

  return (
    <div className="top-contact-bar">
      <Container>
        <div className="contact-info">
          <div className="contact-left">
            <div className="contact-item">
              <FontAwesomeIcon icon={faWhatsapp} className="contact-icon" />
              <span 
                className="contact-text whatsapp-link" 
                onClick={openWhatsAppChat}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && openWhatsAppChat()}
              >
                WhatsApp Us
              </span>
            </div>
            <div className="contact-item">
              <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
              <span 
                className="contact-text email-link" 
                onClick={openEmail}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && openEmail()}
              >
                support@homeworkguy.live
              </span>
            </div>
          </div>
          
          <div className="contact-right">
            <div className="social-links">
              <button 
                className="social-btn discord-btn"
                onClick={openDiscord}
                title="Add On Discord"
                aria-label="Add On Discord"
              >
                <FontAwesomeIcon icon={faDiscord} />
                <span className="social-text">Add On Discord</span>
              </button>
              
              <button 
                className="social-btn instagram-btn"
                onClick={openInstagram}
                title="Follow us on Instagram"
                aria-label="Follow us on Instagram"
              >
                <FontAwesomeIcon icon={faInstagram} />
                <span className="social-text">Instagram</span>
              </button>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TopContactBar;
